import TextSummary from './TextSummary';
export default TextSummary;
//# sourceMappingURL=index.js.map